import React from "react";
import { useEffect, useState } from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { onDownLoadPdfSAT } from "../Dashboard/DashboardFiscalMain";
import { LoaderScreen } from "../../components/LoaderScreen";

export const FacturacionNoRegistradaSection = ({ data }) => {
  const [facturacion, setFacturacion] = useState([]);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    setFacturacion(data);
  }, [data]);

  return (
    <div className="listado-fiscal-invoicemovimientos-container">
      <LoaderScreen loader={loader} />
      <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Documento</th>
              <th>
                <div>Fecha</div>
              </th>
              <th>
                <div>Serie Fiscal</div>
              </th>
              <th>
                <div>UUID</div>
              </th>
              <th>
                <div>Importe</div>
              </th>
              <th>
                <div>Batch</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {facturacion.map((fac) => (
              <tr>
                <td className="ta-center">
                  <div className="options">
                    <div
                      className="boton-pdf"
                      onClick={() =>
                        onDownLoadPdfSAT(fac.documento, loader, setLoader)
                      }
                    >
                      <PictureAsPdfIcon />
                    </div>
                  </div>
                </td>
                <td className="ta-center">{fac.documento}</td>
                <td className="ta-center">
                  {new Date(fac.fecha).toLocaleDateString("es-MX", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </td>
                <td className="ta-center">
                  {fac.serie_fiscal} - {fac.folio_fiscal}
                </td>
                <td className="ta-center">{fac.uuid}</td>
                <td className="ta-right">{FormatMoney(fac.importe)}</td>
                <td className="ta-center">{fac.batch}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
